// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/mcp.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CompleteMcpOAuthRequest, CompleteMcpOAuthResponse, CreateMcpServerRequest, DeleteMcpServerRequest, DeleteMcpServerResponse, DisconnectMcpOAuthRequest, DisconnectMcpOAuthResponse, InitiateMcpOAuthRequest, InitiateMcpOAuthResponse, ListMcpServersRequest, ListMcpServersResponse, McpServer, UpdateMcpServerRequest } from "./mcp_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.McpService
 */
export const McpService = {
  typeName: "omnios.v1.McpService",
  methods: {
    /**
     * @generated from rpc omnios.v1.McpService.CreateMcpServer
     */
    createMcpServer: {
      name: "CreateMcpServer",
      I: CreateMcpServerRequest,
      O: McpServer,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.McpService.UpdateMcpServer
     */
    updateMcpServer: {
      name: "UpdateMcpServer",
      I: UpdateMcpServerRequest,
      O: McpServer,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.McpService.DeleteMcpServer
     */
    deleteMcpServer: {
      name: "DeleteMcpServer",
      I: DeleteMcpServerRequest,
      O: DeleteMcpServerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.McpService.ListMcpServers
     */
    listMcpServers: {
      name: "ListMcpServers",
      I: ListMcpServersRequest,
      O: ListMcpServersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.McpService.InitiateMcpOAuth
     */
    initiateMcpOAuth: {
      name: "InitiateMcpOAuth",
      I: InitiateMcpOAuthRequest,
      O: InitiateMcpOAuthResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.McpService.CompleteMcpOAuth
     */
    completeMcpOAuth: {
      name: "CompleteMcpOAuth",
      I: CompleteMcpOAuthRequest,
      O: CompleteMcpOAuthResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.McpService.DisconnectMcpOAuth
     */
    disconnectMcpOAuth: {
      name: "DisconnectMcpOAuth",
      I: DisconnectMcpOAuthRequest,
      O: DisconnectMcpOAuthResponse,
      kind: MethodKind.Unary,
    },
  }
};

